import React from "react";
import Header from "./Header";
import Banner from "./Banner";
import Footer from "./Footer";
import JoinRoomForm from "./JoinRoomFrom";
export default function HomePage() {
    const onSubmitForm = (pubkey: string, signature: string, toPubkey?: string, toGroupID?: string) => {
        const roomID = toGroupID ? toGroupID : pubkey > toPubkey! ? toPubkey + ":" + pubkey : pubkey + ":" + toPubkey;
        window.location.href = `https://wssdev2.trustkeys.network/roomcall?id=${roomID}&pubkey=${pubkey}&message=${roomID}&sign=${signature}`;
    }
    return (
        <div className="h-screen flex flex-col">
            <Header title="TrustKeys Network Meet" learnMoreLink="#" />
            <main className="container mx-auto px-4 py-16 flex flex-grow justify-center items-center">
                <Banner
                    imageUrl="HeadBanner.png" // Replace with your image path
                    heading="Welcome to TrustKeys Network Meet!"
                    description="Join us for a day of learning, networking, and exploring the future of decentralized trust."
                />
                <JoinRoomForm onSubmit={onSubmitForm} />
            </main>
            <Footer />
        </div>
    );
}